export const CALENDAH_PROVIDERS = {
    HUB_SPOT: 'hubspot',
    GOOGLE: 'google',
    OUTLOOK: 'outlook',
    APPLE: 'apple',
} as const;

export const FILE_PROVIDERS = [
    CALENDAH_PROVIDERS.GOOGLE,
    CALENDAH_PROVIDERS.OUTLOOK,
    CALENDAH_PROVIDERS.APPLE,
] as const;
